import React from 'react';
import { Box, Typography, Modal } from '@mui/material';
import { useUserAndGameContext } from '../../../contexts/UserAndGameContext';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import AddLinkOutlinedIcon from '@mui/icons-material/AddLinkOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const ShareModal = ({ 
  open, 
  onClose, 
}) => {

    const { 
        gameData,
        myUserId, 
    } = useUserAndGameContext();

    // Check if the user is in game administration
    const isUserInGameAdministration = gameData?.gameAdministration?.administrators?.includes(myUserId) || gameData?.gameAdministration?.commissioners?.includes(myUserId);
 
    const shareConfig = gameData?.gameSnackbarInfo?.menuItems?.find(item => item.modal === 'share')?.shareConfig || {};

    // Default share configuration
    const defaultConfig = {
        title: "Share this league",
        smsBody: "Check this out: {url}",
        emailSubject: "Check out this league", 
        emailBody: "Here's the link: {url}",
        copyMessage: "Link copied to clipboard!"
    };

    // Merge provided config with defaults
    const config = { ...defaultConfig, ...shareConfig };

    let url = window.location.href;

    if (myUserId && !isUserInGameAdministration) {
        url = `${url}&invite=true&referralId=${myUserId}`;
    } else if (isUserInGameAdministration) {
        url = `${url}&invite=true`;
    }

    // Helper function to replace {url} placeholder
    const replaceUrlPlaceholder = (text) => {
        return text.replace('{url}', url);
    };

    const copyToClipboard = async () => {
        try {
        await navigator.clipboard.writeText(url);
        alert(config.copyMessage);
        } catch (err) {
        console.error('Failed to copy: ', err);
        }
    };

    const openSMS = () => {
        const smsBody = encodeURIComponent(replaceUrlPlaceholder(config.smsBody));
        window.location.href = `sms:?body=${smsBody}`;
    };

    const openEmail = () => {
        const subject = encodeURIComponent(config.emailSubject);
        const body = encodeURIComponent(replaceUrlPlaceholder(config.emailBody));
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
    };

    const shareItemStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '8px',
        borderRadius: '4px',
        '&:hover': {
        backgroundColor: '#f5f5f5',
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '325px',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#fff',
        padding: '22px',
        boxShadow: 24,
        borderColor: '#e5e7eb !important',
        borderRadius: '8px'
    };

    const modalHeaderStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
    };

    return (
        <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
            <Box sx={modalHeaderStyle}>
            <Typography sx={{ fontWeight: '700', fontSize: '24px' }}>{config.title}</Typography>
            <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-around', flexDirection: 'row', gap: 2 }}>
            <Box sx={shareItemStyle} onClick={copyToClipboard}>
                <AddLinkOutlinedIcon sx={{ width: '45px', height: 'auto' }} />
                <Typography>Copy Link</Typography>
            </Box>
            <Box sx={shareItemStyle} onClick={openSMS}>
                <ChatOutlinedIcon sx={{ width: '45px', height: 'auto' }} />
                <Typography>Text</Typography>
            </Box>
            <Box sx={shareItemStyle} onClick={openEmail}>
                <EmailOutlinedIcon sx={{ width: '45px', height: 'auto' }} />
                <Typography>Email</Typography>
            </Box>
            </Box>
        </Box>
        </Modal>
    );
};

export default ShareModal;